import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../lib/api';

const StoreContext = createContext({});

export const StoreProvider = ({ children }) => {
  const [currentEvent, setCurrentEvent] = useState(null);
  const [staffName, setStaffName] = useState(() => localStorage.getItem('padua_staff') || 'Padua iPad');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        const event = await api.getOrCreateMidsummerEvent();
        setCurrentEvent(event);
      } catch (err) {
        console.error("Failed to initialize local IndexedDB event:", err);
        setCurrentEvent(null);
      }
      setLoading(false);
    };
    
    init();
  }, []);

  const updateStaffName = (name) => {
    setStaffName(name);
    localStorage.setItem('padua_staff', name);
  };

  return (
    <StoreContext.Provider value={{ currentEvent, staffName, updateStaffName, loading }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);